import React from 'react';
import { useTranslate } from '../../mixins/translate/translate';

export interface IStatusLabelProps {
    value?: string | undefined;
}

export function SurveyStatusLabel(props: IStatusLabelProps) {
    const translate = useTranslate();

    if (!props.value) {
        return null;
    }
    const text = translate(`surveyStatus.${props.value}`);
    return (
        <span className={`label survey-label-${props.value}`} title={text}>
            {text}
        </span>
    );
}
